import { Link } from '@cian/ui-kit';
import { IconActionArrowLeft16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './Layout.css';

interface IFormContentProps {
  main: React.ReactNode;
  aside?: React.ReactNode;
  bottom?: React.ReactNode | null;
}

export const Layout = ({ main, aside, bottom }: IFormContentProps) => (
  <div className={styles['container']}>
    <div className={styles['wrapper']}>
      <div>
        <Link
          href="/agentstva/"
          fontSize="S"
          beforeIcon={<IconActionArrowLeft16 color="icon-main-default" />}
          spacingSize="XS"
        >
          Вернуться в каталог агентств
        </Link>
      </div>
      <div className={styles['content']}>
        <main className={styles['main']}>{main}</main>
        {aside && <aside className={styles['aside']}>{aside}</aside>}
      </div>
    </div>
    {bottom && (
      <div>
        <div className={styles['bottom']}>{bottom}</div>
      </div>
    )}
  </div>
);
